const safeJsonStringify = (value) => {
  try {
    return JSON.stringify(value);
  } catch (error) {
    return "";
  }
};

const pickText = (...values) => {
  for (const value of values) {
    if (typeof value === "string" && value.trim() !== "") {
      return value.trim();
    }
  }

  return "";
};

const getErrorText = (error) => {
  if (!error) return "";
  if (typeof error === "string") return error;
  if (Array.isArray(error)) return error.map(getErrorText).filter(Boolean).join(" | ");
  if (typeof error.message === "string") return error.message;
  if (typeof error.error === "string") return error.error;
  if (typeof error.detail === "string") return error.detail;
  if (typeof error.description === "string") return error.description;
  if (Array.isArray(error.errors)) return error.errors.map(getErrorText).filter(Boolean).join(" | ");
  if (typeof error === "object") return safeJsonStringify(error);

  return String(error);
};

const createSupportErrorId = () => {
  const timestamp = Date.now().toString(36).toUpperCase();
  const suffix = Math.random().toString(36).slice(2, 8).toUpperCase();
  return `SP-${timestamp}-${suffix}`;
};

export const normalizeApiError = (error, fallback = {}) => {
  const response = error?.response;
  const data = response?.data;
  const status = response?.status;
  const method = error?.config?.method?.toUpperCase();
  const url = error?.config?.url;
  const headers = response?.headers || error?.config?.headers || {};

  const backendMessage = pickText(
    getErrorText(data?.error),
    getErrorText(data?.message),
    getErrorText(data?.detail),
    getErrorText(data?.errors),
    getErrorText(data)
  );

  const networkMessage = !response
    ? pickText(error?.message, "No se pudo conectar con el servidor.")
    : "";

  const message = pickText(
    backendMessage,
    networkMessage,
    fallback.message,
    "No se pudo completar la operacion."
  );

  const title = pickText(
    fallback.title,
    status ? `Error ${status}` : "",
    "Ocurrio un error"
  );

  const code = pickText(
    getErrorText(data?.code),
    getErrorText(data?.error?.code),
    error?.code
  );

  const supportErrorId = pickText(
    fallback.supportErrorId,
    getErrorText(data?.supportErrorId),
    getErrorText(data?.support_error_id),
    getErrorText(data?.requestId),
    getErrorText(data?.request_id),
    getErrorText(headers["x-request-id"]),
    getErrorText(headers["X-Request-Id"]),
    fallback.includeSupportId ? createSupportErrorId() : ""
  );

  const detailParts = [
    supportErrorId ? `Soporte: ${supportErrorId}` : "",
    status ? `Status: ${status}` : "",
    code ? `Codigo: ${code}` : "",
    method || url ? `Endpoint: ${method || ""} ${url || ""}`.trim() : "",
    fallback.context ? `Contexto: ${fallback.context}` : "",
  ].filter(Boolean);

  return {
    title,
    message,
    icon: fallback.icon || "error",
    status,
    code,
    supportErrorId,
    detail: detailParts.join(" | "),
    raw: data,
  };
};

export const showApiError = (error, fallback = {}, ErrorAlert) => {
  const normalizedError = normalizeApiError(error, fallback);

  if (ErrorAlert) {
    ErrorAlert(
      normalizedError.message,
      normalizedError.title,
      normalizedError.icon,
      fallback.timer,
      {
        detail: normalizedError.detail,
      }
    );
  }

  return normalizedError;
};
